{
  "overridesEnabledBadgeLabel": "Sostituzioni attive"
}
